import PerksModal from './PerksModal.vue'

export default PerksModal
